<section *ngIf="showAddCard">
  <!-- Card form is still loading -->
  <div *ngIf="!isIFrameReady" class="tw-my-8 tw-ml-[9px] tw-flex tw-justify-center" data-cy="card-form-loading">
    <mat-progress-spinner mode="indeterminate" [diameter]="32"></mat-progress-spinner>
  </div>

  <div #eProtectIframeTemplate [hidden]="!isIFrameReady" >
    <div #eProtectiframe class="eProtectiframe" id="eProtectiframe"></div>

    <div #btn id="btn-account" class="col-md-12">
      <button type="button" class="tw-w-full tw-mb-4" id="btn-add" (click)="addCard()" data-cy="card-deposit-add-new" hidden>
        {{ 'account.funding.card.add.header' | translate: 'Add new card' }}
      </button>
      <!-- Inner span keeps the flex layout off the button, whose `hidden`
           attribute is toggled from the component. -->
      <button type="button" class="tw-w-full tw-mb-4" id="btn-adding" hidden disabled>
        <span class="tw-flex tw-items-center tw-justify-center tw-gap-[8px]">
          {{ 'ui.funding.adding.new.card' | translate: 'Adding new card...' }}
          <mat-progress-spinner mode="indeterminate" [diameter]="16"></mat-progress-spinner>
        </span>
      </button>
    </div>
  </div>
</section>
